<template>
    <div class="as-work_advanced_selector">
        <slot name="custorm" >
            <as-selector @click.native="onShowDialog" :label="label" :default="selectViewData"></as-selector>
        </slot>
        <el-dialog width="1000px" @close="onCancel" :append-to-body="true" class="work_dialog_selector" title="选择作品" :visible="dialogVisible" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="selector_main" v-loading="dialogLoading">
                <div class="selector_header">
                    <as-selector placeholder="全部分类" clearable :options="typeList" @change="onChangeType"></as-selector>
                    <shop-advanced-selector placeholder="全部门店" clearable :load-data="loadAreaData" @change="onChangeShop" :multiple="false"></shop-advanced-selector>
                    <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
                </div>
                <div class="selector_content">
                    <el-radio-group v-model="radioValue">
                        <el-radio :label="item.id" v-for="item in listData" :key="item.id">
                            <div class="work_item__emp">
                                <div class="work_item__avatar">
                                    <el-image :src="item.empAvatar" fit="cover">
                                        <div slot="error" class="image-slot">
                                            <as-icon name="touxiang"></as-icon>
                                        </div>
                                    </el-image>
                                </div>
                                <div class="work_item__empinfo">
                                    <p class="work_item__empname">{{ item.empName }}</p>
                                    <p class="work_item__emplevel">{{ item.empLevelName }}</p>
                                </div>
                            </div>
                            <div class="work_item__content">
                                <p class="work_item__title" :title="item.title">{{ item.title }}</p>
                                <div class="work_item__imgs">
                                    <el-image :src="img" fit="cover" v-for="img in item.imageList" :key="img"></el-image>
                                </div>
                            </div>
                            <div class="work_item__mallitem" v-if="item.itemName">
                                <span class="work_item__associated"><as-icon name="associated"></as-icon></span>
                                <p class="work_item__item_name">{{ item.itemName }}</p>
                                <p class="work_item__item_price" v-if="item.price">￥{{ item.price }}</p>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
                <div class="selector_footer">
                    <el-pagination
                        v-if="totalCount > 10"
                        :current-page="currentPage"
                        @current-change="onChangePageNumber"
                        class="selector_pagination"
                        background
                        layout="prev, pager, next"
                        :total="totalCount">
                    </el-pagination>
                    <div class="footer_actions">
                        <el-button size="medium" @click="onCancel">取消</el-button>
                        <el-button size="medium" type="primary" @click="onConfirm">确认</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import AsSelector from '@/components/selector';
    import AdvancedSelector from '@/components/advanced-selector'
    import AsIcon from '@/components/icon'
    import ShopAdvancedSelector from '@/components/shop-advanced-selector'
    export default {
        extends: AdvancedSelector,
        name: 'AsWorkAdvancedSelector',
        components: {
            AsSelector,
            AsIcon,
            ShopAdvancedSelector,
        },
        props: {
            filterMethod: Function,
            defaultSelectView: {
                type: String,
                default: '',
            },
            loadData: Function,
            value: [String, Number],
        },
        data() {
            return {
                shopId: null,
                radioValue: '',
                dialogLoading: true,
                totalCount: 0,
                pageSize: 10,
                pageNumber: 0,
                typeList: [
                    { value: 1, name: "美发" },
                    { value: 4, name: "美甲美睫" },
                    { value: 3, name: "美容美体" },
                    { value: 2, name: "美妆" },
                    { value: 5, name: "手足护理" },
                    { value: 6, name: "其他" },
                ],
                listData: [],
                typeData: null,
                tempTypeData: null,
                tempShopData: null,
                shopData: null,
            }
        },
        computed: {
            currentPage() {
                return this.pageNumber + 1;
            },
            selectViewData() {
                const label = 'name';
                const count = this.selectListData ? this.selectListData.length : 0;
                if (!count) return this.defaultSelectData;
                const appendFixLabel = count > 1 ? `+ ${count - 1}` : '';
                const name = `${this.selectListData[0][label]}${appendFixLabel}`;
                return {
                    name,
                }
            },
        },
        methods: {
            onChangePageNumber(value) {
                this.pageNumber = value - 1;
                this.getListData();
            },
            onCancel() {
                this.dialogVisible = false;
            },
            onConfirm() {
                const data = this.listData.find(item => item.id === this.radioValue)
                if (!data) {
                    this.$message.warning('请选择作品！');
                    return;
                }
                this.$emit('change', data);
                this.onCancel();
            },
            getListData() {
                this.dialogLoading = true;
                this.loadData({
                    type: this.typeData ? this.typeData.value : null,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    shopId: this.shopData ? this.shopData.id : null,
                }, this.loadDataCallback);
            },
            onChangeType(data) {
                this.tempTypeData = data;
            },
            onChangeShop(data) {
                this.tempShopData = data[0];
            },
            onShowDialog() {
                this.dialogVisible = true;
                this.radioValue = this.value;
                if (this.loadData) {
                    this.getListData();
                    return;
                }
            },
            loadAreaData(done) {
                this.loadData({
                    workShopSelectorData: true,
                }, done);
            },
            onSearch() {
                this.typeData = this.tempTypeData ? {...this.tempTypeData} : null;
                this.shopData = this.tempShopData ? { ...this.tempShopData } : null;
                this.pageNumber = 0;
                this.getListData();
            },
            loadDataCallback(resData) {
                this.listData = resData.content;
                this.totalCount = resData.totalCount;
                this.dialogLoading = false;
            },
        }
    }
</script>
<style lang="scss">
.as-work_advanced_selector {
    display: inline-flex;
}
.work_dialog_selector {
    .el-dialog__header {
        padding: 23px 30px 11px 20;
    }
    .el-dialog__title {
        font-size: 13px;
        line-height: 1.27;
        font-weight: 700;
    }
    .el-dialog__body {
        padding: 0 30px 0 20px;
    }
    .el-dialog__headerbtn,
    .el-dialog__close {
        color: #000;
    }
    .el-radio-group {
        width: 100%;
    }
    .el-button {
        border-radius: 2px;
    }
    .el-button--mini {
        padding: 8px 15px;
    }
    .selector_pagination {
        padding: 0;
        margin: 0 -5px;
    }
    .selector_content {
        margin-top: 10px;
        height: 420px;
        overflow-y: auto;
        border: 1px solid #E5E5E5;
        .el-radio {
            width: 100%;
            margin: 0;
            display: flex;
            align-items: center;
            padding: 10px 0;
            &:not(:last-child) {
                border-bottom: 1px solid #e5e5e5;
            }
        }
        .el-radio__input {
            padding-left: 23px;
            padding-right: 18px;
            .el-radio__inner {
                width: 16px;
                height: 16px;
            }
        }
        .el-radio__label {
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
        }
        .work_item__emp {
            display: flex;
            align-items: center;
            width: 130px;
            font-size: 12px;
        }
        .work_item__avatar {
            width: 30px;
            height: 30px;
            margin-right: 8px;
            overflow: hidden;
            border-radius: 100%;
            flex: none;
            .el-image {
                width: 30px;
                height: 30px;
            }
            .image-slot {
                font-size: 30px;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                color: #fff;
                background: #e4e4e4;
            }
        }
        .work_item__empname,
        .work_item__emplevel {
            width: 92px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .work_item__empname {
            font-weight: 700;
            color: #333;
            line-height: 1.3;
        }
        .work_item__emplevel {
            color: #999;
            line-height: 1,3;
        }
        .work_item__title {
            line-height: 1.46;
            font-size: 12px;
            color: #333;
            width: 566px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .work_item__imgs {
            display: flex;
            margin: 0 -5px;
            .el-image {
                margin: 0 5px;
                width: 54px;
                height: 54px;
                border-radius: 2px;
            }
            .el-image__error {
                font-size: 12px;
            }
        }
        .work_item__mallitem {
            position: relative;
            padding-left: 59px;
            width: 175px;
            font-size: 12px;
            color: #333;
            line-height: 1.46;
        }
        .work_item__associated {
            position: absolute;
            top: 50%;
            left: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
            background-color: #e7e7e7;
            border-radius: 100%;
            color: #999;
            font-size: 12px;
        }
        .work_item__item_name {
            white-space: pre-wrap;
        }

    }
    .selector_footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 0 27px 0;
        text-align: right;
        .el-button--primary {
            width: 95px;
            text-align: center;
        }
    }
    .selector_main {
        .as-selector {
            border: 1px solid #e5e5e5;
            border-radius: 3px;
        }
        .as-selector__label {
            display: none;
        }
    }
}
</style>